// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Global responsive helpers */
*, *::before, *::after {
  box-sizing: border-box;
}

img, video {
  max-width: 100%;
  height: auto;
  display: block;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

/* Utility spacing */
.mt-1 { margin-top: 8px; }
.mt-2 { margin-top: 16px; }
.mb-1 { margin-bottom: 8px; }
.mb-2 { margin-bottom: 16px; }

/* Breakpoints */
@media (max-width: 900px) {
  .container { padding: 12px; }
}

@media (max-width: 768px) {
  .container { padding: 8px; }
  h1, h2, h3 { font-size: 1.2rem; }
}



/*    responsive   web  */
@media (max-width: 768px) {

  /* Stack flex items vertically, reduce padding/margins, smaller fonts */
  .container {
    flex-direction: column;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 480px) {

  /* Further reductions for phones */
  .nav-bar {
    font-size: 20px;
    padding: 4px 8px;
  }

  .intro-box {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,oBAAoB;AACpB,QAAQ,eAAe,EAAE;AACzB,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;;AAE7B,gBAAgB;AAChB;EACE,aAAa,aAAa,EAAE;AAC9B;;AAEA;EACE,aAAa,YAAY,EAAE;EAC3B,aAAa,iBAAiB,EAAE;AAClC;;;;AAIA,yBAAyB;AACzB;;EAEE,uEAAuE;EACvE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;EAEE,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Global responsive helpers */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nimg, video {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n/* Utility spacing */\n.mt-1 { margin-top: 8px; }\n.mt-2 { margin-top: 16px; }\n.mb-1 { margin-bottom: 8px; }\n.mb-2 { margin-bottom: 16px; }\n\n/* Breakpoints */\n@media (max-width: 900px) {\n  .container { padding: 12px; }\n}\n\n@media (max-width: 768px) {\n  .container { padding: 8px; }\n  h1, h2, h3 { font-size: 1.2rem; }\n}\n\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n  /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  h1 {\n    font-size: 1.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Further reductions for phones */\n  .nav-bar {\n    font-size: 20px;\n    padding: 4px 8px;\n  }\n\n  .intro-box {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
